import {FileEntry} from "../../interfaces/fileEntry";

export enum ExperienceType{
    Client = 1,
    Project = 2,
    CustomClient = 3,
    CustomProject = 4,
    CustomResponsibility = 5,
    CustomPosition = 6,
    School = 7
}

export enum DegreeType{
  Associate = 1,
  Bachelor = 2,
  Master = 3,
  Doctor = 4
}

export interface Experience {
    id: number,
    is_tenant_root?: boolean,
    start: Date|string,
    end?: Date|string,
    name: string,
    description: string,
    logo?: FileEntry,
    location?: string,
    position?: string,
    company?: string,
    degree?: DegreeType,
    degree_major?: string,
    degree_finished?: boolean,
    url?: string,
    type: ExperienceType,
    items: Experience[]
}
